<template>
  <div>
    <vue-base-dialog  :dialogConfig="dialogConfig" class="selfCreateDialog">
        <div class="dialog-content">
           <p class="content">测评已结束，系统将自动提交测评结果</p>
           <a-button class="button" type="primary" shape="round" @click="submitAssess()">我知道了</a-button>
        </div>
    </vue-base-dialog>
  </div>
</template>

<script>
import VueBaseDialog from '@/components/VueBaseDialog'
import { mapActions, mapState } from "vuex";
export default {
    name:"assessDialog1",
    props:{
        dialogConfig: {
          type: Object,
        }
    },
    components: {
       VueBaseDialog,
    },
    data(){
        return{
            //services: services,
        }
    },
    computed: {
        ...mapState({
            loginUserInfo: (state) => state.appsLogin.appsUserInfo,
        })
    },
    methods:{
        //取消关闭窗口
        cancel(){
            this.$emit("cancleDialog",null);
        },
        //提交测评
        submitAssess(){
            let that = this
            if(that.dialogConfig.data.show_result == 1){
                that.$router.push({
                    //跳转到再次测评页面
                    path: `/${that.loginUserInfo && that.loginUserInfo.school_code}/user/myAssess/againAssess`,
                    query:{
                        ass_id:that.dialogConfig.data.ass_id,
                        assessName:that.dialogConfig.data.assessName,
                        record_id:that.dialogConfig.data.record_id,
                        class_id: that.dialogConfig.data.class_id,
                        tabs:0,
                    }
                });
            } else {
                that.$router.push({
                    //跳转到测评结束页面
                    path: `/${that.loginUserInfo && that.loginUserInfo.school_code}/user/myAssess/endAssess`,
                    query: {
                        time: that.dialogConfig.data.use_duration
                    },
                });
            }
            
            
        }
    },

}
</script>

<style lang="less" scoped>
.dialog-content{
   padding: 20px 40px;
   width: 400px;
   padding-top: 40px;
}
.button{
    border-radius: 5px;
    margin-top: 40px;
}
/deep/.close{
    display: none;
}
.content{
    color: #666666;
}
</style>